import React, {
    useState,
    useEffect,
    useRef,
    forwardRef,
    useImperativeHandle,
} from 'react';
import { useNavigate } from 'react-router-dom';
import Spinner from '../ui/spinners/Spinner';
import DetailsForm from './DetailsForm';
import styles from './AgencyPage.module.scss';
import { ROUTES } from '../../constants/routes';
import { getText } from '../../i18n';
const DetailsTab = forwardRef(({ agencyId, agencyRecord, onSave }, ref) => {
    const navigate = useNavigate();
    const [detailsData, setDetailsData] = useState({});
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);

    const detailsFormRef = useRef();

    useEffect(() => {
        const fetchDetailsData = async () => {
            try {
                setDetailsData(agencyRecord || {});
            } catch (error) {
                console.error('Error retrieving agency details data:', error);
                setError(
                    'Could not fetch details data. Please try again later.',
                );
            } finally {
                setIsLoading(false);
            }
        };

        if (agencyId) {
            fetchDetailsData();
        }
    }, [agencyId]);

    const onReturnToList = () => {
        navigate(ROUTES.AGENCIES);
    };

    const handleCancelClick = () => {
        onReturnToList();
    };

    useImperativeHandle(ref, () => ({
        handleSave,
    }));

    const handleSave = async options => {
        if (!detailsFormRef.current) {
            return { success: false };
        }

        return detailsFormRef.current.handleSave(options);
    };

    if (error) {
        return <p>{error}</p>;
    }

    if (!detailsData) {
        return <p>{getText('msg_44332a23da91')}</p>;
    }

    return (
        <>
            {isLoading ? (
                <Spinner width={50} className={styles.loadingSpinner} />
            ) : (
                <>
                    <div className={styles.detailsTab}>
                        <DetailsForm
                            ref={detailsFormRef}
                            agencyId={agencyId}
                            initialData={detailsData}
                            onSave={onSave}
                            onCancel={handleCancelClick}
                            isCreateMode={false}
                        />
                    </div>
                </>
            )}
        </>
    );
});

export default DetailsTab;
